import type React from 'react';

import cssString from 'cropperjs/dist/cropper.css';

/**
 * Injects the cropperjs library stylesheet globally via a plain <style> element
 * (no emotion/theme-ui). cssString is imported as a raw CSS string by the build.
 */
export const GlobalStyle: React.FC = () => {
	// eslint-disable-next-line react/no-danger
	return <style dangerouslySetInnerHTML={{ __html: cssString }} />;
};
